import { Entity } from "@common/types/entity";
import { EntityFilterCombobox } from "@components/entity/EntityFilter/EntityFilterCombobox";

interface Props {
    entity: Entity;
    onChange: (entityId?: number) => void;
}

export const ReportingEntityFilter = ({ entity, onChange }: Props) => (
    <EntityFilterCombobox
        filters={{ entityIds: [entity.id] }}
        onlyBusiness
        excludeAllMockEntities
        showLabel
        selectionMode="single"
        onChange={({ entityIds }) => onChange(entityIds?.[0])}
    />
);
